import { Redirect } from 'expo-router'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'
import type { TCommunityJoinParams } from '@/src/general/constants/routes'
import { TEST_ID } from '@/src/general/constants/testId'
import { parseIdDash } from '@/src/general/utils/parseIdDash'

import { useCommunityQuery } from '../../services/useCommunityQuery'
import { useCommunitySubscriptionRoute } from '../hooks/useCommunitySubscriptionRoute'

type TCommunityJoinProps = TIdSlugParam & TCommunityJoinParams

export const CommunityJoinScreen = ({ idSlug, course, origin, source }: TCommunityJoinProps): ReactNode => {
  const [id, slug] = parseIdDash(idSlug)

  const { data, isLoading } = useCommunityQuery(id)

  const subscriptionRoute = useCommunitySubscriptionRoute({ id, slug, course, origin, source, ...data })

  if (isLoading)
    return (
      <View testID={TEST_ID.COMMUNITY.JOIN_SCREEN}>
        <PlaceholderMedia size="avatar-lg" />
        <PlaceholderLine />
        <PlaceholderLine />
      </View>
    )

  return <Redirect href={subscriptionRoute} />
}
